import logWaypointEditStarted from '@alltrails/amplitude/events/logWaypointEditStarted';
import { setWaypointEditingState } from '@alltrails/maps/redux/customRoute';
import type { CustomRouteWaypoint } from '@alltrails/types/CustomRoute';
import { VISIBILITY_PUBLIC } from '@alltrails/types/Visibility';
import type { AppDispatch } from '@/utils/redux';

// Shared by every way the advanced builder adds a waypoint, so they start and fill one in alike.

/** Opens the waypoint editor for an add with no waypoint yet; the claim listener closes whatever window was open */
export const startWaypointAdd = () => (dispatch: AppDispatch) => {
  logWaypointEditStarted({ edit_type: 'add_new', entry_point: 'custom_routes' });
  dispatch(setWaypointEditingState({ selectedId: undefined, isEditing: true }));
};

/** The temporary waypoint an add places, until Done saves it or a cancel removes it */
export const getNewWaypoint = (latitude: number, longitude: number): Omit<CustomRouteWaypoint, 'id'> => ({
  contentPrivacy: VISIBILITY_PUBLIC,
  description: '',
  isGlobal: true,
  isTemporary: true,
  latitude,
  longitude,
  name: '',
  showTitle: true
});
